import { createFileRoute } from '@tanstack/react-router';
import { BrandDetailsPage } from '../features/campaigns/BrandDetailsPage/BrandDetailsPage';
import { campaignsRouteSearchSchema } from '../features/campaigns/campaigns/campaignsRouteSearch';
export const Route = createFileRoute('/campaigns/brands_/$brandId/details')({
  validateSearch: campaignsRouteSearchSchema,
  component: DetailsRoute,
});
function DetailsRoute() {
  const { brandId } = Route.useParams();
  return <BrandDetailsPage brandId={brandId} />;
}
